/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLineItemRequest
 */
export interface CreateLineItemRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateLineItemRequest
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLineItemRequest
     */
    quantity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateLineItemRequest
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLineItemRequest
     */
    unitPriceCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLineItemRequest
     */
    taxCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLineItemRequest
     */
    opCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateLineItemRequest
     */
    rcvCents: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLineItemRequest
     */
    lineItemNumber?: string | null;
}

/**
 * Check if a given object implements the CreateLineItemRequest interface.
 */
export function instanceOfCreateLineItemRequest(value: object): value is CreateLineItemRequest {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('rcvCents' in value) || value['rcvCents'] === undefined) return false;
    return true;
}

export function CreateLineItemRequestFromJSON(json: any): CreateLineItemRequest {
    return CreateLineItemRequestFromJSONTyped(json, false);
}

export function CreateLineItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLineItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'unitPriceCents': json['unitPriceCents'] == null ? undefined : json['unitPriceCents'],
        'taxCents': json['taxCents'] == null ? undefined : json['taxCents'],
        'opCents': json['opCents'] == null ? undefined : json['opCents'],
        'rcvCents': json['rcvCents'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
    };
}

export function CreateLineItemRequestToJSON(json: any): CreateLineItemRequest {
    return CreateLineItemRequestToJSONTyped(json, false);
}

export function CreateLineItemRequestToJSONTyped(value?: CreateLineItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'quantity': value['quantity'],
        'unit': value['unit'],
        'unitPriceCents': value['unitPriceCents'],
        'taxCents': value['taxCents'],
        'opCents': value['opCents'],
        'rcvCents': value['rcvCents'],
        'lineItemNumber': value['lineItemNumber'],
    };
}

